import { Outlet } from 'react-router-dom'

const EVCarModel = () => <Outlet />

export default EVCarModel
